
import URI from 'urijs';
import isArray from 'lodash/isArray';
import startsWith from 'lodash/startsWith';

import ErrorHttp from '../../common/client/utils/ErrorHttp';

import loadJsonFromText from '../utils/loadJsonFromText';
import loadJsonFromUrl from '../utils/loadJsonFromUrl';
import loadTextFromUrl from '../utils/loadTextFromUrl';

import Log from '../log';
let log = Log.getLogger('MultiSceneForApp.server.serverApi');

const SCRIPT_NAMES = [
    'MultiSceneForApp.js',
    'MultiSceneForApp.bundle.js',
    'MultiSceneForApp.dev.js',
    'MultiSceneForApp.prod.js'
];

const DEFAULT_API_BASE_URL = '';
const OUTPUT_TYPE_JSON = 'JSON';
const OUTPUT_TYPE_TEXT = 'TEXT';

// ToDo: global variable
let _apiBaseUrl = '';

function callFunctionGet(module, version, name, params, outputType, callback) {
    let url = getFunctionUrl(module, version, name, params);

    callback = callback || (() => {});

    switch (outputType) {
        case OUTPUT_TYPE_JSON:
            loadJsonFromUrl(url, (err, response) => {
                callback(err, response);
            });
            break;
        case OUTPUT_TYPE_TEXT:
            loadTextFromUrl(url, (err, response) => {
                callback(err, response);
            });
            break;
        default:
            log.warn(`Bad type of output for call function: ${outputType}`);
    }
}

function getDefaultRequestOptions(options) {
    let contentType = options.contentType || 'application/json';

    let reqOptions = {
        mode: 'cors',
        headers: {
            'Content-Type': contentType
        }
    };

    if (options.token) {
        reqOptions.headers = {
            ...reqOptions.headers,
            'Authorization': (options.token) ? `Token ${options.token}` : ''
        }
    }

    if (options.reqOptions) {
        reqOptions = {
            ...reqOptions,
            ...options.reqOptions
        };
    }

    return reqOptions;
}

function callGet(options) {
    let url = getFunctionUrl(options.module, options.version, options.name, options.params);
    let callback = options.callback || (() => {});

    let reqOptions = {
        ...getDefaultRequestOptions(options),
        method: 'GET'
    };

    doFetch(url, reqOptions, callback);
}

function callPost(options) {
    let url = getFunctionUrl(options.module, options.version, options.name);
    let callback = options.callback || (() => {});

    let reqOptions = {
        ...getDefaultRequestOptions(options),
        method: 'POST',
        body: JSON.stringify(options.body),
    };

    doFetch(url, reqOptions, callback);
}

function doFetch(url, reqOptions, callback) {
    fetch(url, reqOptions)
        .then(response => {
            if (response.ok) {
                return response.text();
            } else {
                throw new ErrorHttp(
                    'Internal error in call server API',
                    response.status
                );
            }
        })
        .then(content => {
            loadJsonFromText(content, callback);
        })
        .catch(error => {
            log.error('fetch failed:', error);
            callback(error);
        });
}

function getApiBaseUrl() {
    return _apiBaseUrl;
}

// ToDo: version
function getFunctionUrl(module, version, name, params) {
    let url = `${getApiBaseUrl()}/api/${module}/${name}`;
    let uri = new URI(url);
    if (isArray(params)) {
        params.forEach(item => {
            uri.setSearch(item[0], item[1]);
        });
    }

    return uri.toString();
}

function getScriptLocation() {
    let scriptLocation;
    let scripts = document.getElementsByTagName('script');
    for (let i = 0; i < scripts.length; i++) {
        let src = scripts[i].getAttribute('src');
        if (src) {
            scriptLocation = getScriptLocationFromUrl(src);
            if (scriptLocation) {
                break;
            }
        }
    }
    return scriptLocation;
}

function getScriptLocationFromUrl(scriptUrl) {
    let scriptLocation;
    for (let i = 0; i < SCRIPT_NAMES.length; i++) {
        let index = scriptUrl.indexOf(SCRIPT_NAMES[i]);
        if (index > -1) {
            scriptLocation = scriptUrl.slice(0, index);
            break;
        }
    }
    return scriptLocation;
}

function getServerBaseUrlFromScript() {
    let url = getScriptLocation();
    if (startsWith(url, 'http://') || startsWith(url, 'https://')) {
        log.debug('Client API is from server');
        let uri = new URI(url);
        setApiBaseUrl(`${uri.protocol()}://${uri.host()}`);
    } else {
        log.debug('Client API is local');
        setApiBaseUrl(DEFAULT_API_BASE_URL);
    }
}

function init(options) {
    options = options || {};
    initServerBaseUrl(options);
}

function initServerBaseUrl(options) {
    if (options.serverApiUrl) {
        setApiBaseUrl(options.serverApiUrl);
    } else {
        setApiBaseUrl(getServerBaseUrlFromScript());
    }
}

function setApiBaseUrl(url) {
    _apiBaseUrl = url;
    log.debug(`API URL base used: ${_apiBaseUrl}`);
}

export default {
    OUTPUT_TYPE_JSON,
    OUTPUT_TYPE_TEXT,

    callFunctionGet,
    callGet,
    callPost,
    doFetch,
    getApiBaseUrl,
    init
};
